module.exports = __webpack_public_path__ + "img/section2LeftModel.e0cc8d6c.webp";